<ckeditor
  [editor]="Editor"
  (ready)="onReady($event)"
  [(ngModel)]="editorValue"
  [config]="editorConfig"
></ckeditor>

